(function () {
    'use strict';

    angular.module('swif.framework')

    .factory('swifStateService', swifStateService);

    /**
    * @ngdoc service
    * @name swif.framework.swifStateService
    * @requires swif.framework.settingsService
    **/
    function swifStateService(settingsService) {
        'ngInject';
        var settings = settingsService;
        var service = {};
        /**
        * @ngdoc method
        * @name getStateInfo
        * @methodOf swif.framework.swifStateService
        * @description
        * return the info of a given state
        * @param {String} state given state
        * @param {Object} model the object
        * @returns {Ojbect} the state info object
        * ```
        * {{title: 'Draft', stateClass: 'label-info', stateSetting: {settings}}}
        * ```
        * 
        **/
        service.getStateInfo = function (state, model) {
            // by default, display the state key as title of the state-item
            var info = {};
            info.title = state;
            info.stateClass = 'label-default';
            if (!model) {
                return;
            }
            // retrieve the definition of the state attribute (from contentTypes)
            if(model._type) {
                var modelSetting = settings.app.contentTypes[model._type];
                if(modelSetting.states) {
                    info.stateSetting = modelSetting.states[state];
                    if(info.stateSetting) {
                        info.title = info.stateSetting.title;
                        info.stateClass = 'label-' + info.stateSetting.labelclass;
                    }
                    else {
                        console.warn('Unable to retrieve state "' + state + '" from contentType "' + model._type + '"');
                    }
                }
                else {
                    console.warn('Missing attribute "states" on definition of contentType "' + model._type + '"');
                }
            } else {
                // debug mode: this is only when the implementation is missing some settings
                console.warn('Missing attribute "_type" on ngModel');
            }
            return info;
        };
        return service;
    }



})();